var fn = function( obj ){
var __t,__p='';
__p+='varying vec2 vTexCoord;\nvarying vec2 vDotCoord;\n\nuniform sampler2D uDotTex;\nuniform float uAlpha;\n\nvoid main(void){\n\n  vec2 tcoord = vTexCoord;\n  vec4 color = texture2D(uDotTex, vDotCoord);\n  float l = ( ( length(vTexCoord.xy - vec2(0.5) ) ) * 2.0) + (1.0 - uAlpha);\n  float a = 1.0 - l;\n  gl_FragColor = vec4(color.r) * a;\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;